var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAntes({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_6043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_473_6043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1274 15.3097L23.1274 15.3097H23.1261C21.3322 15.3097 19.6117 16.0224 18.3432 17.2908C17.0747 18.5593 16.3621 20.2798 16.3621 22.0737V22.1837H16.2521H14.4922C14.4169 22.1838 14.3433 22.2062 14.2807 22.248C14.2181 22.2899 14.1693 22.3494 14.1405 22.419C14.1117 22.4885 14.1041 22.5651 14.1188 22.639C14.1335 22.7128 14.1697 22.7807 14.2229 22.834L16.9649 25.5759L16.9651 25.5762C17.0004 25.6117 17.0424 25.6399 17.0887 25.6591C17.1349 25.6784 17.1845 25.6883 17.2346 25.6883C17.2847 25.6883 17.3343 25.6784 17.3805 25.6591C17.4268 25.6399 17.4688 25.6117 17.5041 25.5762L17.5043 25.5759L20.2463 22.834C20.2995 22.7807 20.3357 22.7128 20.3504 22.639C20.3651 22.5651 20.3575 22.4885 20.3287 22.419C20.2999 22.3494 20.2511 22.2899 20.1885 22.248C20.1259 22.2062 20.0523 22.1838 19.977 22.1837H18.2161H18.1061V22.0737C18.1061 21.0809 18.4005 20.1103 18.9521 19.2848C19.5037 18.4592 20.2877 17.8158 21.205 17.4358C22.1223 17.0559 23.1317 16.9565 24.1055 17.1502C25.0792 17.3439 25.9737 17.822 26.6758 18.524C27.3778 19.2261 27.8559 20.1206 28.0496 21.0944C28.2433 22.0682 28.1439 23.0775 27.764 23.9948C27.384 24.9121 26.7406 25.6961 25.9151 26.2477C25.0895 26.7993 24.119 27.0937 23.1261 27.0937H22.1459C21.9202 27.1014 21.7062 27.1963 21.5491 27.3585C21.3915 27.5212 21.3034 27.7388 21.3034 27.9652C21.3034 28.1917 21.3915 28.4092 21.5491 28.5719C21.7062 28.7342 21.9202 28.8291 22.1459 28.8367L23.1261 28.8367L23.1274 28.8367C24.0225 28.8475 24.9108 28.6806 25.7408 28.3455C26.5709 28.0104 27.3262 27.514 27.9629 26.8848C28.5997 26.2557 29.1053 25.5065 29.4503 24.6805C29.7953 23.8546 29.973 22.9683 29.973 22.0732C29.973 21.1781 29.7953 20.2919 29.4503 19.4659C29.1053 18.64 28.5997 17.8907 27.9629 17.2616C27.3262 16.6325 26.5709 16.136 25.7408 15.8009C24.9108 15.4659 24.0225 15.2989 23.1274 15.3097Z",
    fill: "#636363",
    stroke: "#F4F4F4",
    strokeWidth: 0.22
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_6043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_473_6043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(-1 0 0 1 30 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntes);
export default __webpack_public_path__ + "static/media/Antes.ee626ec62c74797cf19b691f94a478e7.svg";
export { ForwardRef as ReactComponent };